interface CompanyInfoProps {
  image: any;
  title: string;
  text: string;
}

export const CompanyInfo = ({ image, title, text }: CompanyInfoProps) => {
  return (
    <div
      className="relative max-w-6xl md:mx-auto my-12 overflow-hidden rounded-3xl shadow-xl border border-xencode-gold bg-gradient-to-br from-xencode-black via-[#0f0f0f] to-xencode-contact-black transition-transform duration-300 hover:scale-[1.02]"
      data-aos="fade-up"
    >
      {/* Gold ambient glow */}
      <div className="absolute inset-0 pointer-events-none z-0">
        <div className="absolute -top-16 -left-16 w-80 h-80 bg-xencode-gold opacity-20 rounded-full blur-3xl" />
        <div className="absolute -bottom-16 -right-16 w-80 h-80 bg-xencode-gold opacity-10 rounded-full blur-2xl" />
      </div>

      {/* Content */}
      <div className="relative grid grid-cols-1 md:grid-cols-2 gap-10 items-center px-8 py-12 z-10">
        {/* Image */}
        <div className="flex justify-center md:justify-start">
          <div className="w-56 h-56 rounded-2xl overflow-hidden shadow-2xl border-4 border-xencode-gold p-2 hover:scale-105 transform transition">
            <img src={image} alt="Company Info Visual" className="w-full h-full object-contain" />
          </div>
        </div>

        {/* Text */}
        <div className="text-center md:text-left">
          <h2 className="text-2xl font-extrabold text-xencode-gold mb-4 tracking-widest drop-shadow-md uppercase">
            {title}
          </h2>
          <p className="text-base text-gray-300 leading-relaxed tracking-wide">{text}</p>
        </div>
      </div>
    </div>
  );
};
